import React, { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { api } from "../lib/api";

const SID_KEY = "berulia_chat_sid";

export default function ChatbotWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Bonjour ✿ Je suis Lia, votre conseillère BERULIA. Comment puis-je vous aider ?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  const sid = (() => {
    let s = localStorage.getItem(SID_KEY);
    if (!s) { s = `s-${Math.random().toString(36).slice(2)}-${Date.now()}`; localStorage.setItem(SID_KEY, s); }
    return s;
  })();

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, open]);

  const send = async () => {
    if (!input.trim() || loading) return;
    const text = input.trim();
    setInput("");
    setMessages(m => [...m, { role: "user", content: text }]);
    setLoading(true);
    try {
      const r = await api.post("/chat", { session_id: sid, message: text });
      setMessages(m => [...m, { role: "assistant", content: r.data.reply }]);
    } catch {
      setMessages(m => [...m, { role: "assistant", content: "Désolée, petit souci technique." }]);
    } finally { setLoading(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(o => !o)} data-testid="chatbot-toggle"
        style={{ zIndex: 9999 }}
        className="fixed bottom-6 left-6 bg-berulia-rose hover:bg-berulia-rosedeep text-berulia-ink shadow-lg w-14 h-14 rounded-full flex items-center justify-center transition">
        {open ? <X size={20}/> : <MessageCircle size={20}/>}
      </button>
      {open && (
        <div style={{ zIndex: 9999 }} className="fixed bottom-24 left-6 w-[360px] max-w-[calc(100vw-3rem)] h-[480px] bg-white border border-berulia-border shadow-xl flex flex-col" data-testid="chatbot-panel">
          <div className="bg-berulia-rose px-4 py-3 border-b border-berulia-border">
            <p className="font-heading text-lg">Lia <span className="font-serif-italic text-sm text-berulia-ink/60">conseillère BERULIA</span></p>
          </div>
          <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3 text-sm">
            {messages.map((m,i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`px-3 py-2 max-w-[80%] ${m.role === "user" ? "bg-berulia-rosedeep text-berulia-inkdeep" : "bg-berulia-beigewarm text-berulia-ink"}`}>{m.content}</div>
              </div>
            ))}
            {loading && <div className="text-berulia-inkmuted text-xs italic">Lia écrit…</div>}
          </div>
          <div className="border-t border-berulia-border p-3 flex gap-2">
            <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()}
              data-testid="chatbot-input"
              placeholder="Posez votre question…" className="flex-1 px-3 py-2 text-sm bg-berulia-beige outline-none border border-berulia-border focus:border-berulia-rosedeep"/>
            <button onClick={send} data-testid="chatbot-send" className="bg-berulia-rosedeep text-berulia-inkdeep px-3"><Send size={14}/></button>
          </div>
        </div>
      )}
    </>
  );
}
